import { useState, useEffect } from 'react';
import { Divider, Paper } from '@mui/material';
import { PlayLogoSection } from '../components/Media/PlayLogoSection';
import { ShowLogoOnThumbnailsSection } from '../components/Media/ShowLogoOnThumbnailsSection';
import { ShowOtherTeamsMatchClipsSection } from '../components/Highlights/ShowOtherTeamsMatchClipsSection';
import { StandardCategoryClipCountSection } from '../components/Highlights/StandardCategoryClipCountSection';
import { useFotbollPlaySubmit } from '../api/FotbollPlaySubmitProvider';
import { DEFAULT_STANDARD_CATEGORY_CLIP_COUNT, type SettingsTabPayload } from '../api/types';

interface MediaTabProps {
  teamAbbrv: string;
  config?: SettingsTabPayload;
}

export function MediaTab({ teamAbbrv, config }: MediaTabProps) {
  const [playLogo, setPlayLogo] = useState(config?.playLogo ?? '');
  const [showLogoOnThumbnails, setShowLogoOnThumbnails] = useState(
    config?.showLogoOnThumbnails ?? false
  );
  const [showOtherTeamsMatchClips, setShowOtherTeamsMatchClips] = useState(
    config?.showOtherTeamsMatchClips ?? false
  );
  const [standardCategoryClipCount, setStandardCategoryClipCount] = useState(
    config?.standardCategoryClipCount ?? DEFAULT_STANDARD_CATEGORY_CLIP_COUNT
  );
  const { registerTabPayload } = useFotbollPlaySubmit();

  useEffect(() => {
    setPlayLogo(config?.playLogo ?? '');
    setShowLogoOnThumbnails(config?.showLogoOnThumbnails ?? false);
    setShowOtherTeamsMatchClips(config?.showOtherTeamsMatchClips ?? false);
    setStandardCategoryClipCount(
      config?.standardCategoryClipCount ?? DEFAULT_STANDARD_CATEGORY_CLIP_COUNT
    );
  }, [config]);

  useEffect(() => {
    return registerTabPayload(0, () => ({
      playLogo,
      showLogoOnThumbnails,
      showOtherTeamsMatchClips,
      standardCategoryClipCount,
    }));
  }, [
    playLogo,
    registerTabPayload,
    showLogoOnThumbnails,
    showOtherTeamsMatchClips,
    standardCategoryClipCount,
  ]);

  return (
    <Paper variant="outlined" sx={{ mt: 3, mx: 3, p: 0 }}>
      <PlayLogoSection teamAbbrv={teamAbbrv} playLogo={playLogo} onPlayLogoChange={setPlayLogo} />
      <Divider />
      <ShowLogoOnThumbnailsSection
        showLogoOnThumbnails={showLogoOnThumbnails}
        onShowLogoOnThumbnailsChange={setShowLogoOnThumbnails}
      />
      <Divider />
      <ShowOtherTeamsMatchClipsSection
        showOtherTeamsMatchClips={showOtherTeamsMatchClips}
        onShowOtherTeamsMatchClipsChange={setShowOtherTeamsMatchClips}
      />
      <Divider />
      <StandardCategoryClipCountSection
        standardCategoryClipCount={standardCategoryClipCount}
        onStandardCategoryClipCountChange={setStandardCategoryClipCount}
      />
    </Paper>
  );
}
